    <p class="inline-block">
        {{ errorMessage?.text }}
        <ng-content></ng-content>
    </p>
